import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";

export const getfpyMissReasonParetoData = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_FPY_MISS_REASON_PARETO_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_FPY_MISS_REASON_PARETO_DATA,
      payload: res.data,
    });
  });
};

export const fetchShifts = (dispatch, qry) => {
  AsyncCallHandler(
    "FPY/GetDailyInputTarget?tierId=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_FPY_TARGET", payload: res.data });
  });
};
export const fetchDleResons = (dispatch, qry) => {
  AsyncCallHandler(
    "FPY/getRejectedReasonCodeList?tierId=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "DLE_REASONS", payload: res.data });
  });
};
export const addDailyInput = (dispatch, data) => {
  AsyncCallHandler("FPY/ManageDailyInputData", NEXUS_CONST.POST, data).then(
    (res) => {
      dispatch({
        type: "REFRESH_FPY_WIDGET",
        payload: new Date(),
      });
    }
  );
};
export const fetchShift = (dispatch, qry) => {
  AsyncCallHandler(
    "FPY/GetDailyInputDetails?tierId=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_FPY_SHIFT", payload: res.data });
  });
};

export const fetchReasonCodeLevel0 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=0&isRejected=true`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_O", payload: res.data });
  });
};

export const fetchReasonCodeLevel1 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=1&isRejected=true`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_1", payload: res.data });
  });
};

export const fetchReasonCodeLevel2 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=2&isRejected=true`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_2", payload: res.data });
  });
};

